export default __webpack_public_path__ + "static/Entenda0130-0a140fd5ae708c66db99a60633c50416.jpg";